// 001검단 002광교 010용인 011일산 012군산 014 강서 017대구B 020검단B 023춘천 025익산 026부산 029전주B 030부산B 034천안 035김해 044전주A
// 크래프트 추가 대구A015 성남027 창원013
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { validateUrlCode, trackPageClick } from "../utils/api";
import NotFound from "../pages/NotFound";

// 병원 관련 모든 컴포넌트를 동적으로 import합니다.
const components = {
  A001: React.lazy(() => import("../pages/001/A001")), // 검단A
  A002: React.lazy(() => import("../pages/002/A002")), // 광교
  A003: React.lazy(() => import("../pages/003/A003")), // 의정부
  A004: React.lazy(() => import("../pages/004/A004")), // 강릉
  A005: React.lazy(() => import("../pages/005/A005")), // 춘천A
  A006: React.lazy(() => import("../pages/006/A006")), // 은평
  A010: React.lazy(() => import("../pages/010/A010")), // 용인
  A011: React.lazy(() => import("../pages/011/A011")), // 일산
  A012: React.lazy(() => import("../pages/012/A012")), // 군산
  A013: React.lazy(() => import("../pages/013/A013")), // 창원 (craft)
  A014: React.lazy(() => import("../pages/014/A014")), // 강서
  A015: React.lazy(() => import("../pages/015/A015")), // 대구A
  A017: React.lazy(() => import("../pages/017/A017")), // 대구B
  A020: React.lazy(() => import("../pages/020/A020")), // 검단B
  A028: React.lazy(() => import("../pages/028/A028")), // 대구C (craft)
  A023: React.lazy(() => import("../pages/023/A023")), // 춘천B
  A025: React.lazy(() => import("../pages/025/A025")), // 익산
  A026: React.lazy(() => import("../pages/026/A026")), // 부산
  A027: React.lazy(() => import("../pages/027/A027")), // 성남 (craft)
  A029: React.lazy(() => import("../pages/029/A029")), // 전주B
  A030: React.lazy(() => import("../pages/030/A030")), // 부산B
  A031: React.lazy(() => import("../pages/031/A031")), // 부천 (craft)
  A034: React.lazy(() => import("../pages/034/A034")), // 천안
  A032: React.lazy(() => import("../pages/032/A032")), // 광주
  A033: React.lazy(() => import("../pages/033/A033")), // 테스트
  A035: React.lazy(() => import("../pages/035/A035")), // 김해
  A036: React.lazy(() => import("../pages/036/A036")), // 전국
  A037: React.lazy(() => import("../pages/037/A037")), // 구리
  A039: React.lazy(() => import("../pages/039/A039")), // 동탄
  A040: React.lazy(() => import("../pages/040/A040")), // 이천
  A042: React.lazy(() => import("../pages/042/A042")), // 검단C
  A043: React.lazy(() => import("../pages/043/A043")), // 구리
  A044: React.lazy(() => import("../pages/044/A044")), // 전주A
  A045: React.lazy(() => import("../pages/045/A045")), // 안산
  A048: React.lazy(() => import("../pages/048/A048")), // 창원B
  A999: React.lazy(() => import("../pages/999/A999")), // 개발팀
};

function Hospital() {
  const [urlCodeSettingId, setUrlCodeSettingId] = useState(null);
  const [getData, setGetData] = useState(null);
  // null: 검증 전, true: 통과, false: 실패
  const [validated, setValidated] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { hospitalNumber, adnumber, urlCode } = useParams();

  useEffect(() => {
    // TODO: 테스트 후 제거 - urlCode "test"일 때 검증 우회
    if (urlCode === "test") {
      setValidated(true);
      setUrlCodeSettingId(0);
      setIsLoading(false);
      return;
    }

    const fetchUrlCodeSetting = async () => {
      try {
        const data = await validateUrlCode(urlCode);
        const ok =
          data.ad_number === adnumber && data.hospital_code === hospitalNumber;

        setValidated(ok);
        if (ok) {
          setUrlCodeSettingId(data.id);
          setGetData(data);
        }
      } catch (error) {
        console.error(error);
        setValidated(false);
      } finally {
        setIsLoading(false);
      }
    };

    if (urlCode && adnumber && hospitalNumber) {
      fetchUrlCodeSetting();
    } else {
      setValidated(false);
      setIsLoading(false);
    }
  }, [urlCode, adnumber, hospitalNumber]);

  // 클릭 카운트는 검증 통과 시에만
  useEffect(() => {
    if (!isLoading && validated) {
      const timer = setTimeout(() => {
        trackPageClick(urlCodeSettingId);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [isLoading, validated, urlCodeSettingId]);

  // 1) 로딩 중
  if (isLoading) {
    return <div>Loading...</div>;
  }

  // 2) 검증 실패
  if (validated === false) {
    return (
      <>
        <style>{`.rafinity-main-img{display:block;width:80%;height:auto;margin:0 auto}@media (max-width:768px){.rafinity-main-img{width:100%}}`}</style>
        <img
          className="rafinity-main-img"
          src="https://smilevent-assets.s3.ap-northeast-2.amazonaws.com/images/rafinity/rafinity_main.png"
          alt="main"
        />
      </>
    );
  }

  // 3) 검증 통과
  const HospitalComponent = components[`A${hospitalNumber}`];
  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      {HospitalComponent && (
        <HospitalComponent
          urlCode={urlCode}
          urlCodeSettingId={urlCodeSettingId}
        />
      )}
    </React.Suspense>
  );
}

export default Hospital;
